import React, { useState, useEffect } from 'react';
import { X, Sparkles, MapPin } from 'lucide-react';
import { promotion, salonInfo } from '../data/mock';

export const PromoBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const hasSeenPromo = sessionStorage.getItem('promoSeen');
    if (!hasSeenPromo && promotion.active) {
      setTimeout(() => setIsVisible(true), 1500);
    }
  }, []);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
      sessionStorage.setItem('promoSeen', 'true');
    }, 500);
  };

  const handleCTA = () => {
    const message = `¡Hola! Vi la promoción de apertura en Calimaya con 30% de descuento y me gustaría agendar una cita.`;
    const whatsappUrl = `https://wa.me/${salonInfo.whatsapp.replace(/\+/g, '')}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
    handleClose();
  };

  if (!isVisible) return null;

  return (
    <div className={`fixed inset-0 z-50 flex items-center justify-center p-4 transition-all duration-500 ${isClosing ? 'opacity-0' : 'opacity-100'}`}>
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
        onClick={handleClose}
      />
      
      {/* Modal */}
      <div className={`relative w-full max-w-lg transform transition-all duration-500 ${isClosing ? 'scale-95 opacity-0' : 'scale-100 opacity-100'}`}>
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-neutral-900 via-neutral-800 to-neutral-900 shadow-2xl border border-[#d4af37]/30">
          {/* Decorative gold elements */}
          <div className="absolute -top-20 -right-20 h-40 w-40 rounded-full bg-[#d4af37]/10 blur-3xl" />
          <div className="absolute -bottom-20 -left-20 h-40 w-40 rounded-full bg-[#d4af37]/10 blur-3xl" />
          
          {/* Gold border accent at top */}
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#d4af37] to-transparent" />
          
          {/* Close button */}
          <button
            onClick={handleClose}
            className="absolute right-4 top-4 z-10 rounded-full bg-neutral-800/80 p-2 text-neutral-400 shadow-sm transition-all hover:bg-neutral-700 hover:text-white"
          >
            <X className="h-5 w-5" />
          </button>

          {/* Content */}
          <div className="relative p-8 text-center">
            {/* Badge */}
            <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-[#d4af37]/20 px-4 py-1.5 text-sm font-medium text-[#d4af37] border border-[#d4af37]/30">
              <MapPin className="h-4 w-4" />
              {promotion.badge}
            </div>

            {/* Title */}
            <h2 className="font-serif text-2xl font-bold text-white md:text-3xl">
              {promotion.title}
            </h2>

            {/* Discount */}
            <div className="my-6">
              <div className="relative inline-block">
                <span className="text-7xl font-bold bg-gradient-to-r from-[#d4af37] via-[#f4e5c2] to-[#d4af37] bg-clip-text text-transparent md:text-8xl">
                  {promotion.discount}
                </span>
                <Sparkles className="absolute -right-6 -top-2 h-8 w-8 text-[#d4af37] animate-pulse" />
                <Sparkles className="absolute -left-4 bottom-4 h-6 w-6 text-[#f4e5c2] animate-pulse" style={{ animationDelay: '0.5s' }} />
              </div>
              <p className="mt-2 text-lg text-neutral-300">
                {promotion.description}
              </p>
            </div>

            {/* Decorative line */}
            <div className="mx-auto mb-6 flex items-center justify-center gap-3">
              <div className="h-px w-16 bg-gradient-to-r from-transparent to-[#d4af37]/50" />
              <div className="h-2 w-2 rounded-full bg-[#d4af37]" />
              <div className="h-px w-16 bg-gradient-to-l from-transparent to-[#d4af37]/50" />
            </div>

            {/* CTA Button */}
            <button
              onClick={handleCTA}
              className="group relative overflow-hidden rounded-full bg-gradient-to-r from-[#d4af37] to-[#b8860b] px-8 py-4 text-lg font-semibold text-neutral-900 shadow-lg transition-all duration-300 hover:shadow-xl hover:shadow-[#d4af37]/20"
            >
              <span className="relative z-10 flex items-center justify-center gap-2">
                <Sparkles className="h-5 w-5" />
                {promotion.cta}
              </span>
              <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-[#f4e5c2] to-[#d4af37] transition-transform duration-300 group-hover:translate-x-0" />
            </button>

            {/* Footer text */}
            <p className="mt-4 text-sm text-neutral-500">
              Válido por tiempo limitado en sucursal Calimaya
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
